import React from 'react';
import { ArrowRight, Check, ShieldCheck } from 'lucide-react';
export function CTASection() {
  return <section id="pricing" className="py-16 md:py-24 bg-white border-t border-[#C4705A]/10" data-id="element-1">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-2">
        <h2 className="font-serif text-3xl md:text-5xl text-[#2D2A26] mb-6" data-id="element-3">
          Empieza hoy tu camino al alivio
        </h2>

        <p className="text-xl text-[#2D2A26]/70 mb-10" data-id="element-4">
          Descarga "Alivio de Cuello y Espalda en 14 Días" y haz tu primer Reset
          de Pausa en los próximos 10 minutos.
        </p>

        <div className="bg-[#FAF8F5] p-8 rounded-2xl border-2 border-[#C4705A]/20 shadow-xl mb-10 max-w-xl mx-auto" data-id="element-5">
          <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-6">
            <span className="text-5xl font-bold text-[#2D2A26]" data-id="element-7">$6.39</span>
            <span className="text-[#2D2A26]/50 text-lg" data-id="element-8">USD</span>
          </div>
          <p className="text-[#C4705A] font-medium text-sm mb-8" data-id="element-9">
            Pago único • Acceso de por vida
          </p>

          <a href="https://www.coneckta.store/cart/47553368424692:1" className="w-full bg-[#C4705A] hover:bg-[#A65D4A] text-white px-8 py-4 rounded-lg font-semibold text-xl transition-colors flex items-center justify-center gap-2 shadow-lg mb-6" data-id="element-10">
            Descargar Ahora
            <ArrowRight className="w-6 h-6" data-id="element-11" />
          </a>

          <div className="space-y-3 text-left max-w-xs mx-auto" data-id="element-12">
            <div className="flex items-center gap-3 text-sm text-[#2D2A26]/80" data-id="element-13">
              <Check className="w-4 h-4 text-[#C4705A] flex-shrink-0" data-id="element-14" />
              <span data-id="element-15">7 minutos, 3 veces al día</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-[#2D2A26]/80" data-id="element-16">
              <Check className="w-4 h-4 text-[#C4705A] flex-shrink-0" data-id="element-17" />
              <span data-id="element-18">Test 60s para elegir tu rutina</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-[#2D2A26]/80" data-id="element-19">
              <Check className="w-4 h-4 text-[#C4705A] flex-shrink-0" data-id="element-20" />
              <span data-id="element-21">Sin equipo, 100% en casa</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-[#2D2A26]/80" data-id="element-22">
              <Check className="w-4 h-4 text-[#C4705A] flex-shrink-0" data-id="element-23" />
              <span data-id="element-24">Para mujeres ocupadas (25–65+)</span>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 text-sm text-[#2D2A26]/50" data-id="element-25">
          <ShieldCheck className="w-4 h-4" data-id="element-26" />
          <span data-id="element-27">Garantía de satisfacción. Compra 100% segura.</span>
        </div>
      </div>
    </section>;
}